import {RolePermissionType} from '../../backend/enums/role-permission-type';
import {
  BADL_SECTOR_ID,
  IADL_SECTOR_ID,
  CLINICAL_SUPPORT_SECTOR_ID,
  PERSONAL_DEVELOPMENT_SECTOR_ID,
} from '../constants';

/**
 * Get the activity name by activity section id.
 * Returns ABVD, AIVD, Apoio Clínico or Desenvol. pessoal.
 */
export const getActivityNameByActivitySectorId = (
  activitiesSectorId?: string
): RolePermissionType | '' => {
  let activity: RolePermissionType | '' = '';

  switch (activitiesSectorId) {
    case BADL_SECTOR_ID.toString():
      activity = RolePermissionType.Settings_BADL;
      break;
    case IADL_SECTOR_ID.toString():
      activity = RolePermissionType.Settings_IADL;
      break;
    case CLINICAL_SUPPORT_SECTOR_ID.toString():
      activity = RolePermissionType.Settings_ClinicalSupport;
      break;
    case PERSONAL_DEVELOPMENT_SECTOR_ID.toString():
      activity = RolePermissionType.Settings_PersonalDevelopment;
      break;
    default:
      activity = '';
      break;
  }
  return activity;
};
